import React, { useEffect, useState, useRef, useCallback } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store/store-provider';
import ImageLoadContainer from '../shared/image-load-container/image-load-container';
import TransparentButton from '../shared/transparent-button/transparent-button';
import ExitFullscreenIcon from '../../assets/icons/fullscreen_exit.svg';
import { openFullscreen } from '../../utils/helpers/polls-helper';
import { debounceCallback } from '../../utils/helpers/debounce-callback';

const PresenterFullsrceenSlide = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const hideExitButtonTime = 5000;
    const [image, setImage] = useState('');
    const [showExitButton, setShowExitButton] = useState(true);
    const { slideManagementStore } = useStore();
    const { getSlideManagementEntity, toggleFullscreenModeAction } = slideManagementStore;
    const { getActivePointer } = getSlideManagementEntity();
    const largeThumbnail = getActivePointer().getLargeThumbnail();

    const debouncedExitButtonSetter = useCallback(debounceCallback(setShowExitButton, hideExitButtonTime), []);

    const onMouseMoveHandler = useCallback(() => {
      setShowExitButton(true);
      debouncedExitButtonSetter(false);
    }, []);

    const handleScreenChange = useCallback(() => {
       // @ts-ignore
      const noBrowserFullscreen = !document.fullscreenElement && !document.webkitIsFullScreen && !document.msFullscreenElement && !document.mozFullScreen;

      if (noBrowserFullscreen) {
        toggleFullscreenModeAction();
      }
    }, []);


    useEffect(() => {
      const image = new Image();
      image.src = largeThumbnail;
      image.onload = () => setImage(image.src);
    }, [largeThumbnail]);

    useEffect(() => {
      const elem = containerRef.current;
      if (!elem) return;

      openFullscreen(elem);

      document.addEventListener('webkitfullscreenchange', handleScreenChange);
      document.addEventListener('mozfullscreenchange', handleScreenChange);
      document.addEventListener('fullscreenchange', handleScreenChange);
      document.addEventListener('MSFullscreenChange', handleScreenChange);

      return () => {
        document.removeEventListener('webkitfullscreenchange', handleScreenChange);
        document.removeEventListener('mozfullscreenchange', handleScreenChange);
        document.removeEventListener('fullscreenchange', handleScreenChange);
        document.removeEventListener('MSFullscreenChange', handleScreenChange);
      };
    }, []);

    useEffect(() => {
      debouncedExitButtonSetter(false);

      return () => {
        debouncedExitButtonSetter.cancel();
      };
    }, []);

    return (
      <div className='presenter-fullscreen-slide-wrapper' ref={containerRef} onMouseMove={onMouseMoveHandler}>
        {showExitButton && (
          <TransparentButton customClasses='presenter-fullscreen-slide-exit-button' onClick={toggleFullscreenModeAction}>
            <img src={ExitFullscreenIcon} alt='Exist fullscreen icon'/>
          </TransparentButton>
        )}
        {image && (
          <ImageLoadContainer
            imageSource={image}
            attributes={{
                'aria-labelledby': 'Slide',
                'alt': '',
                'role': 'img'
            }}
            className='presenter-fullscreen-slide-image'
          />
        )}
      </div>
    );
};

export default observer(PresenterFullsrceenSlide);
